import secureLocalStorage from "react-secure-storage";

const TYPE_KEY = 'type';

export const setUserTypeInSecureStorage = (type: string) => {
  secureLocalStorage.setItem(TYPE_KEY, type);
}

export const getUserTypeFromSecureStorage = () => {
  return secureLocalStorage.getItem(TYPE_KEY);
}

